// extracted by mini-css-extract-plugin
module.exports = {"erp-enquiry":"ErpEnquiry_erp-enquiry__f7_tZ","container":"ErpEnquiry_container__Eg3MI"};